import { makeStyles, alpha } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.caption.fontSize,
    flexGrow: 1,
    flexShrink: 1,
    padding: theme.spacing(0.5, 0, 1, 0),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '&:hover $openButton': {
      background: 'none',
      display: 'block'
    }
  },
  details: {
    padding: theme.spacing(0, 0.75, 0, 0.75),
    marginBottom: 2,
    height: theme.spacing(4),
    display: 'flex',
    alignItems: 'stretch',
    cursor: 'pointer',
    '&:hover': {
      background: alpha(theme.palette.action.active, 0.15)
    }
  },
  allocation: {
    textAlign: 'center',
    width: '100%'
  },
  resource: {
    padding: 0,
    flexShrink: 1,
    display: 'flex',
    width: '65%'
  },
  atDivider: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(0.75, 0, 0.25, 0)
  },
  loading: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.75)
  },
  userName: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.75),
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  noResourcesMessage: {
    flexGrow: 1,
    flexShrink: 1,
    lineHeight: 3.5,
    padding: theme.spacing(0, 0, 0, 1)
  },
  openButton: {
    padding: theme.spacing(0.5, 0, 0.5, 0.5),
    margin: theme.spacing(0.5, -0.5, 0, 0),
    opacity: 1,
    width: '15%'
  },
  container: {
    width: '20%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: 1
  },
  tooltipDetails: {
    margin: theme.spacing(0.5, 0, 0, 0)
  }
}));

export default useStyles;
